import React from 'react';
import "./Headimg.css";
import Logo from "./assets/logo_black.png";
import Ministrypic from "./assets/Ministrypic.png";
import kipmainlogo from "./assets/kipmainlogo.png"

const Headimg = () => {
  return (
    <div className="image-gallery">
      <img src={Logo} alt="Image 1" className="gallery-image" />
      <img src={Ministrypic} alt="Image 2" className="gallery-image2" />
      <img src={kipmainlogo} alt="Image 3" className="gallery-image" />
    </div>
  );
};

export default Headimg;
